import { computed } from 'vue'
import { isString, state, type MultiplayerSession } from '../state'
import { ensureModuleBuilds, ensurePlayerBuildsForMultiplayerSessions } from './build-service'
import { cache } from './cache'

export type MultiplayerSessionWithDate = MultiplayerSession & { parsedDate: Date }

export const multiplayerSessionsWithDate = computed(() =>
  Object.values(state.multiplayerSessions).map(
    (x): MultiplayerSessionWithDate => ({ ...x, parsedDate: new Date(x.date) })
  )
)

export function ensureMultiplayerSessionDependencies() {
  return Promise.all([ensureMultiplayerModules(), ensurePlayerBuildsForMultiplayerSessions()])
}

async function ensureMultiplayerModules() {
  const ensureBuildIds = [
    ...Object.values(state.registeredStates).map(x => x.moduleBuildId),
    ...Object.values(state.registeredStates)
      .filter(x => x.overrideId)
      .map(x => x.overrideId!),
    ...Object.values(state.courses).map(x => x.buildId),
    ...Object.values(state.multiplayerSessions)
      .flatMap(x => x.buildIdsByPlatform['quest']?.[0])
      .filter(isString)
  ]
  const stateBuildIds = new Set(Object.keys(state.moduleBuilds))
  const moduleBuildIds = ensureBuildIds.filter(x => !stateBuildIds.has(x))
  if (moduleBuildIds.length === 0) {
    return
  }
  const moduleBuilds = await ensureModuleBuilds(moduleBuildIds)
  await cache.setItems(moduleBuilds)
}
